'use strict';

/**
 * Helper class to handler native rest ajax call.
 */
var util = {
    /**
     * Return the clean current path.
     * Ej:
     * <code>/#/myUrl >> /myUrl</code>
     * @returns {*}
     */
    getCurrentPath() {
        return window.location.hash.indexOf('#') > -1 ? window.location.hash.split('#')[1] : window.location.hash;
    },

    /**
     * Return the value of the given cookie.
     * @param name
     * @returns {String}
     */
    getCookie(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    },

    formatQueryString(filter) {
        if (filter &&  JSON.stringify(filter) !== '{}')   {
            return '?' + Object.keys(filter)
                            .map(key => key + '=' + filter[key])
                            .join('&');
        } else {
            return '';
        }
    },

    /**
     * Return the XSRF-TOKEN value from cookie.
     * @param name
     * @returns {String}
     */
    getCookieXSRF() {
        return this.getCookie('XSRF-TOKEN');
    },

    /**
     * Delete the cooke defined.
     * @param name
     */
    deleteCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    /**
     * Delete the specific XSRF cooke defined.
     * @param name
     */
    deleteXSRFCookie() {
        document.cookie = 'XSRF-TOKEN=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    /**
     * Return the rest client in cross browser compatibility way.
     * @returns {*}
     */
    createXHR() {
        try {
            return new XMLHttpRequest();
        } catch (e) {
            try {
                return new ActiveXObject('Microsoft.XMLHTTP');
            } catch (e) {
                return new ActiveXObject('Msxml2.XMLHTTP');
            }
        }
    },

    getCORSSafeUrl(myUrl) {
        //  But if you make it from a browser, then it will work without problem ...
        // However to make it work, we are going to use the cors-anywhere free service to bypass this
        const proxy = 'https://sheltered-waters-34503.herokuapp.com/';
        return proxy + myUrl;
    },

    /**
     * Generic handler of HTTP response.
     * @param self
     * @param success
     * @param failure
     */
    handlerResponse(self, success, failure) {
        if (this._isUnauthenticated(self)) {
            window.location = '#/login?continue=' + this.getCurrentPath();
            if (failure) {
                failure.bind(self)();
            }
        } else if (this._isUnauthorized(self)) {
            window.location = '#/login?continue=' + this.getCurrentPath();
            if (failure) {
                failure.bind(self)();
            }
        } else if (this._isFailure(self)) {
            if (failure) {
                failure.bind(self)(this.getMessageResonse(self.responseText));
            }
        } else {
            if (success) {
                success.bind(self)();
            }
        }
    },
    /**
     * Generic handler of HTTP response, in case of any error happens, just log out.
     * @param self
     * @param success
     * @param failure
     */
    handlerResponseWithFullLogout(self, success, failure) {
        if (this._isUnauthenticated(self)) {
            window.location = '#/login?continue=' + this.getCurrentPath();
            if (failure) {
                failure.bind(self)();
            }
        } else if (this._isUnauthorized(self)) {
            window.location = '#/login?continue=' + this.getCurrentPath();
            if (failure) {
                failure.bind(self)();
            }
        } else if (this._isFailure(self)) {
            window.location = '#/login?continue=' + this.getCurrentPath();
            if (failure) {
                failure.bind(self)(this.getMessageResonse(self.responseText));
            }
        } else {
            if (success) {
                success.bind(self)();
            }
        }
    },

    /**
     * Standard way to retrieve message from request response.
     * @param response
     * @returns {*}
     */
    getMessageResonse(response) {
        return response ? JSON.parse(response).message : response;
    },

    _isUnauthenticated(self) {
        return self.status === 401;
    },

    _isUnauthorized(self) {
        return self.status === 403;
    },

    _isFailure(self) {
        return self.status >= 400;
    }
};

module.exports = util;



/** WEBPACK FOOTER **
 ** ./src/utils/RestUtils.js
 **/